<template>
    <div>
        <div class="weui-cells__title">修改身份证号码</div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd">
                    <label class="weui-label">身份证号</label>
                </div>
                <div class="weui-cell__bd">
                    <input class="weui-input" type="number" v-model="idCardNo" oninput="if(value.length>18)value=value.slice(0,18)" placeholder="请输入身份证号" style="text-align: right;" />
                </div>
            </div>
        </div>

        <div class="warehousing-footer-item sureinwarehousing" style="flex:2" @click="save">
            <a href="javascript:;">提 交</a>
        </div>
    </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
import commonUtil from "../../utils/commonUtil.js";

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      idCardNo: ""
    };
  },
  created() {
    let that = this;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then(response => {
        that.idCardNo = response.data.data.idCardNo;
        console.log(that.idCardNo);
      })
      .catch(error => {
        weui.topTips("获取用户信息失败", 2000);
      });
  },
  methods: {
    save() {
      let that = this;
      if (!this.idCardNo) {
        weui.alert("身份证号码不能为空");
        return;
      } else if (this.idCardNo.length != 15 && this.idCardNo.length != 18) {
        weui.alert("身份证号码不正确");
        return;
      }
      let check = commonUtil.checkIdCardNo(this.idCardNo);
      console.log(check);
      if (!check) {
        weui.alert("身份证号码不正确");
        return;
      }
      axios
        .put("/api/user/updateIdCardNo", { idCardNo: that.idCardNo })
        .then(res => {
          if (res.data.success) {
            weui.toast("保存成功", 1000);
            // 跳转回个人中心页面
            that.$router.push("/userInfo/express/" + that.encodeToken);
          } else {
            weui.alert(res.data.message);
          }
        })
        .catch(err => {
          weui.alert("保存失败");
        });
    }
  }
};
</script>

<style scoped>
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  background-color: #1aad19;
  margin-top: 10px;
  line-height: 50px;
}
.warehousing-footer-item a {
  color: #ffffff;
}
</style>





// WEBPACK FOOTER //
// src/components/userinfos/IdCardNoEdit.vue